<template>
  <div>
    <el-dialog
      :show-close="showClose"
      class="comn_dialog"
      :title="dialogTitle"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :close-on-press-escape="false"
      :append-to-body="appendToBody"
      :width="popupWidth"
      :top="popupTop"
      :center="center"
      @close="Cancel">
     <span slot="title">
          <div class="flex-sb">
          <div>
          <img v-if="dialogType=='success'" src="@/assets/img/common/icon-sucess@2x.png" alt="">
          <img v-if="dialogType=='warning'" src="@/assets/img/common/icon-warning@2x.png" alt="">
          <i>{{dialogTitle}}</i>
       </div>
       </div>
     </span>
     <p v-if="dialogContent!=''">
       {{dialogContent}}
     </p>
      <slot v-else>
        <p>弹窗内容自定义</p>
      </slot>
      <span slot="footer" class="dialog-footer" v-show="showBtn">
        <el-button class="cancel" v-if="isShowCancel" @click="Cancel">取 消</el-button>
        <el-button type="primary" @click="Save" >确定</el-button>
        <div class="tip-wrap" v-show="showTip">提交后，可在规格申请菜单查询审核进度，审核通过后才可使用。</div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    dialogType: {
      type: String,
      default: "success"
    },
     dialogContent: {
      type: String,
      default: ""
    },
    dialogTitle: {
      type: String,
      default: "标题"
    },
    centerDialogVisible: {
      type: Boolean,
      default() {
        return false;
      }
    },
    center: {
      type: Boolean,
      default() {
        return false;
      }
    },
    showClose: {
      type: Boolean,
      default() {
        return true;
      }
    },
    appendToBody: {
      type: Boolean,
      default() {
        return true;
      }
    },
    popupWidth: {
      type: String,
      default() {
        return "430px";
      }
    },
    popupTop: {
      type: String,
      default() {
        return "23vh";
      }
    },
    showBtn: {
      type: Boolean,
      default() {
        return true;
      }
    },
    showTip:{
       type: Boolean,
      default() {
        return false;
      }
    },
     isShowCancel: {
      type: Boolean,
      default() {
        return true;
      }
    },
  },
  computed: {
    visible: {
      get() {
        return this.centerDialogVisible;
      },
      set(val) { // 当visible改变的时候，触发父组件的 updateVisible方法，在该方法中更改传入子组件的 centerDialogVisible的值
        this.$emit("updateVisible", val);
      }
    }
  },
  methods: {
    Cancel() {
     this.$emit("resetPopupData");
    },
    Save() {
     this.$emit("submitPopupData"); //
    }
  }
};
</script>
<style lang="scss" scoped>
.comn_dialog {
    .back-icon{
        cursor: pointer;
    }
  .el-dialog__header {
    padding: 10px 20px;
    border-bottom: 1px solid #EDEDED;
    // box-shadow: 0px 4px 4px -4px #d1d0d0;
    background: #F5F5F5;
    font-size: 0;
    /* line-height: 1; */
    /* height: 18px; */
    height: 40px;
    span{
      font-size: 14px;
      color: #333;

      img{
        width: 18px;
        height: 18px;
        float: left;
        margin-right: 10px;
      }
    }
  }
  .el-dialog__title {
    font-size: 16px;
    letter-spacing: 1px;
    color: #464646;
    font-weight: bolder;
  }
  .el-dialog__footer {
    padding: 0px !important;
    text-align: center;
  }
  .el-dialog__headerbtn {
    position: static; // 兼容IE11 ,取消原有的position定位
  }
  .el-dialog__close {
    // color: $header_bg;
    font-size: 20px;
    font-weight: bolder;
    position: absolute;
    top: 10px;
    right: 8px;
    &::after {
      content: '';
    //   border: 2px solid $header_bg;
      width: 20px;
      height: 20px;
      border-radius: 25px;
      position: absolute;
      right: -2px;
      top: -3px;
    }
  }
  .tip-wrap{
    color: #999;
    font-size: 14px;
    margin-top: 20px;
  }
  .el-button {
    width: 80px;
    height: 30px;
        padding: 0;
    border-radius: 0;
  }
  .el-button--primary{
    background-color: #2587FF;
    width: 80px;
    height: 30px;
    &:hover,:active{
      background-color: #126EDF;
    }
  }
  .cancel{
    &:hover,:active{
      border: 1px solid #2587FF;
      color: #2587FF;
      background: #F5F5F5;
    }
  }
}
::v-deep  .el-dialog__footer {
  padding: 0px !important;
  text-align: center;
}
::v-deep  .el-dialog__body {
  padding: 20px;
    max-height: 900px;
}
</style>
